module.exports = __webpack_public_path__ + "static/iphonex-truaccent-32d4d1c55ccca49be7002cdbb9ae9ed6.png";